import "./Contact.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  FaEnvelope,
  FaFacebook,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";

import { SOCIAL_LINKS } from "../../config/socials";
import useAnimation from "../../hooks/useAnimation";

const Contact = () => {
  const { t } = useTranslation();
  const { animateFadeInWithMove, animateWithScroll } = useAnimation();

  const initAnimation = () => {
    const section = document.querySelectorAll(".contactSection");
    animateFadeInWithMove(section, 0.6, section);
    animateWithScroll({
      element: ".blobDiv",
      endY: 0,
      startY: -200,
      startTrigger: "top+=10% bottom",
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(initAnimation, 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="contactSectionDiv" id="contact">
      <section className="contactSection">
        <h1>{t("contact.title")}</h1>
        <div className="contactGrid">
          <div className="contactItem">
            <FaMapMarkerAlt className="icon" />
            <p>2 rue du champ binette, 1380 Lasne</p>
          </div>
          <div className="contactItem">
            <FaPhoneAlt className="icon" />
            <p>
              <a href={`tel:${SOCIAL_LINKS.phone}`}>{SOCIAL_LINKS.phone}</a>
            </p>
          </div>
          <div className="contactItem">
            <FaEnvelope className="icon" />
            <p>
              <a
                href={`mailto:${SOCIAL_LINKS.email}`}
                target="_blank"
                rel="noreferrer"
              >
                {SOCIAL_LINKS.email}
              </a>
            </p>
          </div>
          <div className="contactItem">
            <FaFacebook className="icon" />
            <p>
              <a
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
